import "../scss/style.scss";
import Splide from '@splidejs/splide';

/*------------------------------------------
	common
------------------------------------------*/
// SP menu
$(function() {
	$('.js-nav-btn').on('click',function() {
		$('.js-nav').fadeToggle();
		$(this).toggleClass('is-close');
	});
	$('.js-nav a[href^="#"]').on('click',function() {
		$('.js-nav').fadeOut();
		$('.js-nav-btn').removeClass('is-close');
	});
});

// child menu
$(function() {
	$('.js-nav-parent').on('click', function() {
		$('+ .js-nav-child', this).slideToggle();
		$(this).toggleClass('is-open');
	});
});

// Google Ads: 電話予約タップ conversion
$(document).on('click', 'a[href^="tel:"]', function(e) {
	e.preventDefault();
	return gtag_report_conversion(this.href);
});


/*------------------------------------------
	top
------------------------------------------*/
// js-top-mv-slider
if(document.getElementsByClassName('js-top-mv-slider').length) {
		document.addEventListener( 'DOMContentLoaded', function() {
		var jsTopMvSlider_option	=	{
					type					:	'fade',
					rewind				:	true,
					speed					:	3000,
					arrows				:	false,
					pagination		: false,
					autoplay			:	true,
					pauseOnHover	:	false,
					pauseOnFocus	:	false,
				},
				jsTopMvSlider = new Splide( '.js-top-mv-slider', jsTopMvSlider_option );
		jsTopMvSlider.mount();
	});
}

// top kyousei banner
$(function() {
	var $banner = $('.js-top-kyousei-banner');
	if (!$banner.length) {
		return;
	}

	$banner.on('click', '.js-top-kyousei-banner-close', function(e) {
		e.preventDefault();
		e.stopPropagation();
		$banner.addClass('is-hidden');
	});
});